module.exports = __webpack_public_path__ + "static/media/sunnyBLogo.d02b7954.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sunnyBLogo.svg
// module id = 705
// module chunks = 0